import React from 'react';

const PharmacyBilling = () => {
    return (
        <div>
            <h1>Pharmacy Billing</h1>
        </div>
    );
};

export default PharmacyBilling;